import React from 'react';
import { ProjectPersonnelStats } from './ProjectPersonnelStats';
import { ProjectPersonnelDistribution } from './ProjectPersonnelDistribution';
import { ProjectPersonnelContractors } from './ProjectPersonnelContractors';
import { ProjectPersonnelCosts } from './ProjectPersonnelCosts';

export function ProjectPersonnelSidebar({ data }: { data: any }) {
  return (
    <div className="space-y-6">
      {/* Cơ cấu nhân sự */}
      <ProjectPersonnelStats />

      {/* Phân bổ theo vai trò */}
      <ProjectPersonnelDistribution />

      {/* Nhà thầu tham gia */}
      <ProjectPersonnelContractors contractors={data.contractors} />

      {/* Chi phí nhân sự */}
      <ProjectPersonnelCosts />
    </div>
  );
}
